<template>
  <div>
    <div v-if="isFromBill">
      <!-- 提单页 展示返回入口 -->
      <bill-footer />
    </div>
    <div v-else>
      <!-- 新老客-未开通会员   展示开通入口 -->
      <div v-show="isNoBuyStatus">
        <buy-footer :membership="membership" @onSuccess="handleSuccess" />
      </div>
      <!-- 已开通-未订阅 && 允许订阅 的状态  展示订阅入口-->
      <div v-show="isShowSubscription">
        <subscribe-footer
          :membership="membership"
          :headInfo="headInfo"
          @onSuccess="handleSuccess"
        />
      </div>
      <!-- 老客-已开通&暂停订阅  展示恢复订阅入口 -->
      <div v-show="isBuyPauseStatus">
        <pause-footer
          :smallStyle="source ? true : false"
          :membership="membership"
          @onSuccess="handleSuccess"
        />
      </div>
    </div>
    <!-- 成功提示框 -->
    <member-success-dialog
      v-model="isShowSuccessDialog"
      :dialogData="dialogData"
      :type="successDialogType"
      :source="source"
    />
  </div>
</template>

<script>
// 目前该组件供：会员首页、暂停页使用
import { mapState } from 'vuex'
import BuyFooter from './buy-footer.vue'
import PauseFooter from './pause-footer.vue'
import BillFooter from './bill-footer.vue'
import SubscribeFooter from './subscribe-footer.vue'
import mixin from '@/page/member/mixins.js'
import MemberSuccessDialog from './member-success-dialog.vue'

export default {
  name: 'MemberFooter',
  components: {
    BuyFooter,
    PauseFooter,
    BillFooter,
    SubscribeFooter,
    MemberSuccessDialog,
  },
  mixins: [mixin],
  props: {
    headInfo: {
      type: Object,
      default: () => {},
    },
    // 上层页面来源
    source: {
      type: String,
      default: '', // memberManagerMain、管理页  member 首页
    },
  },
  data() {
    return {
      isShowSuccessDialog: false,
      successDialogType: '',
      dialogData: {},
    }
  },
  computed: {
    ...mapState(['membership', 'paySuccessInfo']),
    // 允许订阅
    isCanSubscribe() {
      return this.membership?.canSubscribe
    },
    isShowSubscription() {
      // 已开通-未订阅 && 允许订阅 的状态
      return this.isBuyNoSubscriptionStatus && this.isCanSubscribe
    },
  },
  methods: {
    async handleSuccess(data) {
      /** @desc globalone 命中特型购买成功样式 */
      if (this.membership?.showFirstJoinMemberStyle) {
        return
      }

      if (data) {
        this.isShowSuccessDialog = true
        this.dialogData = data.dialogData
        if (!this.dialogData?.iconUrl) {
          this.dialogData.iconUrl = this.paySuccessInfo?.iconUrl || ''
        }
        this.successDialogType = data.type
      }
    },
  },
}
</script>
